<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import ActionButton from "../ActionButton/ActionButton.svelte";
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { CardsPageContext, CardsPageContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { JanusSignonManagerToken, SSOResult } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOSetState } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { t } from "../../../../../js/i18n";
import { isNil } from 'lodash';
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const pageContext = getContext(CardsPageContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: firstNameKey = (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.firstNameKey;
$: lastNameKey = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.lastNameKey;
$: firstEmailKey = (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.emailKey;
$: emailValidKey = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.isValidEmailKey;
$: firstPhoneKey = (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.phoneKey;
$: isPhoneRequired = isNil((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.isPhoneRequired) ? true : (_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.isPhoneRequired;
$: phoneValidKey = (_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.isValidPhoneKey;
$: birthdateKey = (_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.birthdateKey;
$: genderKey = (_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.genderKey;
$: addressKey = (_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m.addressKey;
$: passwordKey = (_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o.passwordKey;
$: passwordValidKey = (_p = element === null || element === void 0 ? void 0 : element.data) === null || _p === void 0 ? void 0 : _p.isValidPasswordKey;
$: smsOptinKey = (_q = element === null || element === void 0 ? void 0 : element.data) === null || _q === void 0 ? void 0 : _q.smsOptinKey;
$: emailOptinKey = (_r = element === null || element === void 0 ? void 0 : element.data) === null || _r === void 0 ? void 0 : _r.emailOptinKey;
$: privacyOptinKey = (_s = element === null || element === void 0 ? void 0 : element.data) === null || _s === void 0 ? void 0 : _s.privacyOptinKey;
$: newsletterOptinKey = (_t = element === null || element === void 0 ? void 0 : element.data) === null || _t === void 0 ? void 0 : _t.newsletterOptinKey;
$: newsletter2OptinKey = (_u = element === null || element === void 0 ? void 0 : element.data) === null || _u === void 0 ? void 0 : _u.newsletter2OptinKey;
$: dismissAfterLogin = ((_v = element === null || element === void 0 ? void 0 : element.data) === null || _v === void 0 ? void 0 : _v.dismissAfterLogin) || false;
$: endWorkflow = (_w = element === null || element === void 0 ? void 0 : element.data) === null || _w === void 0 ? void 0 : _w.endWorkflow;
$: useCognitoRegistration = ((_x = element === null || element === void 0 ? void 0 : element.data) === null || _x === void 0 ? void 0 : _x.useCognitoRegistration) || false;
$: cognitoUsernameType = ((_y = element === null || element === void 0 ? void 0 : element.data) === null || _y === void 0 ? void 0 : _y.cognitoUsernameType) || 'EMAIL';
$: requireVerification = ((_z = element === null || element === void 0 ? void 0 : element.data) === null || _z === void 0 ? void 0 : _z.requireVerification) || false;
$: buttonLabel = ((_0 = element === null || element === void 0 ? void 0 : element.data) === null || _0 === void 0 ? void 0 : _0.buttonLabel) || "Next";
$: nextPageUrl = ((_1 = element === null || element === void 0 ? void 0 : element.data) === null || _1 === void 0 ? void 0 : _1.nextPageUrl) || null;
$: loginPageUrl = ((_2 = element === null || element === void 0 ? void 0 : element.data) === null || _2 === void 0 ? void 0 : _2.loginPageUrl) || 'Login';
$: useSportsAllianceRegistration = ((_3 = element === null || element === void 0 ? void 0 : element.data) === null || _3 === void 0 ? void 0 : _3.useSportsAllianceRegistration) || false;
$: firstName = firstNameKey ? ($mergedParams || {})[firstNameKey] : '';
$: lastName = lastNameKey ? ($mergedParams || {})[lastNameKey] : '';
$: email = firstEmailKey ? ($mergedParams || {})[firstEmailKey] : '';
$: isEmailValid = emailValidKey ? ($mergedParams || {})[emailValidKey] : '';
$: phone = firstPhoneKey ? ($mergedParams || {})[firstPhoneKey] : '';
$: isPhoneValid = !isPhoneRequired ? "true" : (phoneValidKey ? ($mergedParams || {})[phoneValidKey] : '');
$: birthdate = birthdateKey ? ($mergedParams || {})[birthdateKey] : '';
$: address = addressKey ? ($mergedParams || {})[addressKey] : '';
$: gender = genderKey ? ($mergedParams || {})[genderKey] : '';
$: password = passwordKey ? ($mergedParams || {})[passwordKey] : '';
$: passwordValid = passwordValidKey ? ($mergedParams || {})[passwordValidKey] : '';
$: smsOptin = smsOptinKey ? ($mergedParams || {})[smsOptinKey] : '';
$: emailOptin = emailOptinKey ? ($mergedParams || {})[emailOptinKey] : '';
$: privacyOptin = privacyOptinKey ? ($mergedParams || {})[privacyOptinKey] : '';
$: newsletterOptin = newsletterOptinKey ? ($mergedParams || {})[newsletterOptinKey] : '';
$: newsletter2Optin = newsletter2OptinKey ? ($mergedParams || {})[newsletter2OptinKey] : '';
$: console.log('account_register: ', firstName, lastName, email, isEmailValid, phone, isPhoneValid, password, passwordValid, firstEmailKey, firstPhoneKey, birthdate, address, gender, passwordKey, smsOptin, emailOptin, privacyOptin, newsletterOptin, newsletter2Optin);
// Until validation is fixed
//$: isValid = !!(firstName && lastName && isEmailValid === 'true' && passwordValid === 'true');
$: isValid = !!(firstName && lastName && (firstEmailKey ? isEmailValid === "true" : true) && (firstPhoneKey ? isPhoneValid === "true" : true) && (passwordValidKey ? passwordValid === "true" : true) && ((smsOptinKey && firstPhoneKey) ? (smsOptin === 'true' && phone) || smsOptin === 'false' : true) && (emailOptinKey ? emailOptin === 'true' : true) && (privacyOptinKey ? privacyOptin === 'true' : true));
const handleClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
    var _4, _5, _6, _7, _8, _9, _10;
    f7.preloader.show();
    try {
        const profile = {
            email
        };
        if (firstNameKey) {
            profile.first_name = firstName;
        }
        if (lastNameKey) {
            profile.last_name = lastName;
        }
        if (firstNameKey && lastNameKey) {
            profile.name = firstName + " " + lastName;
        }
        if (firstPhoneKey) {
            profile.phone = phone;
        }
        if (addressKey) {
            profile.address = address;
        }
        if (birthdateKey) {
            profile.birthdate = birthdate;
        }
        if (genderKey) {
            profile.gender = gender;
        }
        if (smsOptinKey)
            profile.sms_optin = smsOptin === "true" ? 'true' : 'false';
        if (emailOptinKey)
            profile.email_optin = emailOptin === "true" ? 'true' : 'false';
        if (privacyOptinKey)
            profile.privacy_optin = privacyOptin === "true" ? 'true' : 'false';
        if (newsletterOptinKey)
            profile.newsletter_optin = newsletterOptin === "true" ? 'true' : 'false';
        if (newsletter2OptinKey)
            profile.newsletter2_optin = newsletter2Optin === "true" ? 'true' : 'false';
        let result = { success: false };
        if (useCognitoRegistration) {
            const phone_number = profile.phone = `+${profile.phone}`; // Cognito requires phone numbers to be prefixed with +
            result = yield signonManager.registerWithCognitoUserPassword((cognitoUsernameType === 'PHONE') ? phone_number : email, password, profile);
        }
        else if (useSportsAllianceRegistration) {
            result = yield signonManager.registerWithSportsAllianceUserPassword(email, password, profile);
        }
        else {
            result = yield signonManager.registerWithYinzCamEmailPassword(email, password, profile);
        }
        console.log('SSO: register result', result);
        if (result.success) {
            if (!requireVerification) {
                if (useCognitoRegistration) {
                    result = yield signonManager.loginWithCognitoUsernamePassword((cognitoUsernameType === 'PHONE') ? profile.phone : email, password);
                }
                else {
                    // this is not required
                    //result = await signonManager.loginWithYinzCamUserPassword(email, password);
                }
            }
            if ((_4 = result.data) === null || _4 === void 0 ? void 0 : _4.Ticket) {
                ycSSOSetState(result.data.AccountCreated === 'true', result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            }
            // TODO: Determine if user needs to complete profile?
            const ssoRedirectAfterLogin = window.localStorage.getItem('ssoRedirectAfterLogin');
            window.localStorage.removeItem('ssoRedirectAfterLogin');
            if (dismissAfterLogin || endWorkflow) {
                signonManager.fireWorkflowEndEvent();
            }
            else if (ssoRedirectAfterLogin) {
                setTimeout(() => {
                    window.location.href = ssoRedirectAfterLogin;
                }, 1000);
            }
            else if (nextPageUrl) {
                resolveUrl(nextPageUrl).func();
            }
            else if (requireVerification) {
                resolveUrl(`VerifyAccount?firstName=${firstName}&lastName=${lastName}&email=${email}&phone=${phone}`).func();
            }
            else if (signonManager.skipCompleteProfilePage) {
                resolveUrl(`ConnectAccounts`).func();
            }
            else {
                resolveUrl(`CompleteProfile?firstName=${firstName}&lastName=${lastName}&email=${email}`).func();
            }
        }
        else {
            alert(((_6 = (_5 = result.data) === null || _5 === void 0 ? void 0 : _5.UserMessage) === null || _6 === void 0 ? void 0 : _6.Content) || 'An error occurred.');
            if (((_8 = (_7 = result.data) === null || _7 === void 0 ? void 0 : _7.UserMessage) === null || _8 === void 0 ? void 0 : _8.Title) === 'Email Verification' || ((_10 = (_9 = result.data) === null || _9 === void 0 ? void 0 : _9.UserMessage) === null || _10 === void 0 ? void 0 : _10.Title) === 'Email Already Registered') {
                resolveUrl(loginPageUrl).func();
            }
        }
    }
    finally {
        f7.preloader.hide();
    }
});
</script>
<CardBase {element}>
    <ActionButton onClick={handleClick} title={$t(buttonLabel)} disabled={!isValid}/>
</CardBase>
